export var BusinessTaxIdConfigsFactory = (function() {
    var getTaxIdConfigs = function(countryCode) {
        switch (countryCode) {
        case 'AU':
            return {
                showField: true,
                showFieldInMinimal: false,
                showTaxIdPossessionFields: false,
                countryName: 'Australia',
                label: 'ABN',
                format: '99-999-999-999',
                allowData: 'numbers-only',
                fieldInService: 'BUS_REG',
                fieldInSAP: 'VAT'
            };
        case 'NZ':
            return {
                showField: true,
                showFieldInMinimal: false,
                showTaxIdPossessionFields: false,
                countryName: 'New Zealand',
                label: 'GST',
                format: '999-999-999',
                allowData: 'numbers-only',
                fieldInService: 'TAX_ID',
                fieldInSAP: 'TAX2'
            };
        case 'GB':
            return {
                showField: true,
                showFieldInMinimal: false,
                showTaxIdPossessionFields: false,
                countryName: 'United Kingdom',
                label: 'VAT',
                format: 'GB999999999',
                allowData: 'numbers-only',
                fieldInService: 'VAT',
                fieldInSAP: 'VAT'
            };
        case 'ES':
            return {
                showField: true,
                showFieldInMinimal: false,
                showTaxIdPossessionFields: false,
                countryName: 'Spain',
                label: 'IVA',
                format: 'ES999999999',
                allowData: 'numbers-only',
                fieldInService: 'VAT',
                fieldInSAP: 'VAT'
            };
        case 'FR':
            return {
                showField: true,
                showFieldInMinimal: true,
                showTaxIdPossessionFields: true,
                countryName: 'France',
                label: 'Siret',
                format: '99999999999999',
                allowData: 'numbers-only',
                fieldInService: 'BUS_REG',
                fieldInSAP: 'TAX3'
            };
        case 'ID':
            return {
                showField: true,
                showFieldInMinimal: false,
                showTaxIdPossessionFields: false,
                countryName: 'Indonesia',
                label: 'NPWP (Tax ID number)',
                format: '99.999.999.9-999.999',
                allowData: 'numbers-only',
                fieldInService: 'KPP',
                fieldInSAP: 'Tax4'
            };
        case 'AR':
            return {
                showField: true,
                showFieldInMinimal: false,
                showTaxIdPossessionFields: false,
                countryName: 'Argentina',
                label: 'CUIT (Clave Única de Identificación Tributaria)',
                format: '999999999999',
                allowData: 'numbers-only',
                fieldInService: 'TAX_ID',
                fieldInSAP: 'TAX1'
            };
        case 'CO':
            return {
                showField: true,
                showFieldInMinimal: false,
                showTaxIdPossessionFields: false,
                countryName: 'Colombia',
                label: 'NIT Número de Identificación Tributaria',
                format: '99999999',
                allowData: 'numbers-only',
                fieldInService: 'BUS_REG',
                fieldInSAP: 'TAX3'
            };
        case 'MX':
            return {
                showField: true,
                showFieldInMinimal: false,
                showTaxIdPossessionFields: false,
                countryName: 'Mexico',
                label: 'Federal taxpayer registration number',
                format: undefined,
                allowData: 'alphanumerics-only',
                fieldInService: 'IDENTITY',
                fieldInSAP: 'TAX2'
            };
        case 'VN':
            return {
                showField: true,
                showFieldInMinimal: false,
                showTaxIdPossessionFields: false,
                countryName: 'Vietnam',
                label: 'Tax Code',
                format: '9999999999',
                allowData: 'numbers-only',
                fieldInService: 'BUS_REG',
                fieldInSAP: 'TAX3'
            };
        case 'DE':
            return {
                showField: true,
                showFieldInMinimal: false,
                showTaxIdPossessionFields: false,
                countryName: 'Germany',
                label: 'VAT',
                format: 'DE999999999',
                allowData: 'numbers-only',
                fieldInService: 'VAT',
                fieldInSAP: 'VAT'
            };
        case 'NO':
            return {
                showField: true,
                showFieldInMinimal: false,
                showTaxIdPossessionFields: false,
                countryName: 'Norway',
                label: 'VAT',
                format: '999999999',
                allowData: 'numbers-only',
                fieldInService: 'VAT',
                fieldInSAP: 'VAT'
            };
        case 'SE':
            return {
                showField: true,
                showFieldInMinimal: false,
                showTaxIdPossessionFields: false,
                countryName: 'Sweden',
                label: 'VAT',
                format: 'SE999999999999',
                allowData: 'numbers-only',
                fieldInService: 'VAT',
                fieldInSAP: 'VAT'
            };
        case 'ZA':
            return {
                showField: true,
                showFieldInMinimal: false,
                showTaxIdPossessionFields: false,
                countryName: 'South Africa',
                label: 'Income Tax Number',
                format: '9999-999-99-9',
                allowData: 'numbers-only',
                fieldInService: 'TAX_ID',
                fieldInSAP: 'TAX1'
            };
        case 'AT':
            return {
                showField: true,
                showFieldInMinimal: false,
                showTaxIdPossessionFields: false,
                countryName: 'Austria',
                label: 'VAT',
                format: 'ATU99999999',
                allowData: 'numbers-only',
                fieldInService: 'VAT',
                fieldInSAP: 'VAT'
            };
        case 'FI':
            return {
                showField: true,
                showFieldInMinimal: false,
                showTaxIdPossessionFields: false,
                countryName: 'Finland',
                label: 'VAT',
                format: 'FI99999999',
                allowData: 'numbers-only',
                fieldInService: 'VAT',
                fieldInSAP: 'VAT'
            };
        case 'DK':
            return {
                showField: true,
                showFieldInMinimal: false,
                showTaxIdPossessionFields: false,
                countryName: 'Denmark',
                label: 'VAT',
                format: 'DK99999999',
                allowData: 'numbers-only',
                fieldInService: 'VAT',
                fieldInSAP: 'VAT'
            };
        case 'IT':
            return {
                showField: true,
                showFieldInMinimal: false,
                showTaxIdPossessionFields: false,
                countryName: 'Italy',
                label: 'VAT',
                format: 'IT99999999999',
                allowData: 'numbers-only',
                fieldInService: 'VAT',
                fieldInSAP: 'VAT'
            };
        case 'IE':
            return {
                showField: true,
                showFieldInMinimal: false,
                showTaxIdPossessionFields: false,
                countryName: 'Ireland',
                label: 'VAT',
                format: 'IE9*99999*',
                allowData: 'alphanumerics-only',
                fieldInService: 'VAT',
                fieldInSAP: 'VAT'
            };
        case 'IS':
            return {
                showField: true,
                showFieldInMinimal: false,
                showTaxIdPossessionFields: false,
                countryName: 'Iceland',
                label: 'VAT',
                format: '999999',
                allowData: 'numbers-only',
                fieldInService: 'VAT',
                fieldInSAP: 'VAT'
            };
        case 'NL':
            return {
                showField: true,
                showFieldInMinimal: false,
                showTaxIdPossessionFields: false,
                countryName: 'The Netherlands',
                label: 'VAT',
                format: 'NL999999999B99',
                allowData: 'numbers-only',
                fieldInService: 'VAT',
                fieldInSAP: 'VAT'
            };
        case 'PT':
            return {
                showField: true,
                showFieldInMinimal: false,
                showTaxIdPossessionFields: false,
                countryName: 'Portugal',
                label: 'VAT',
                format: 'PT999999999',
                allowData: 'numbers-only',
                fieldInService: 'VAT',
                fieldInSAP: 'VAT'
            };
        case 'PF':
            return {
                showField: true,
                showFieldInMinimal: false,
                showTaxIdPossessionFields: false,
                countryName: 'French Polynesia',
                label: 'Numéro TAHITI',
                format: '*99999',
                allowData: 'alphanumerics-only',
                fieldInService: 'VAT',
                fieldInSAP: 'VAT'
            };
        case 'US':
            return {
                showField: false,
                showFieldInMinimal: true,
                showTaxIdPossessionFields: false,
                countryName: 'United States',
                label: 'EIN',
                format: '99-9999999',
                allowData: 'numbers-only',
                fieldInService: 'FEDERAL',
                fieldInSAP: 'TAX1'
            };
        case 'CA':
            return {
                showField: false,
                showFieldInMinimal: true,
                showTaxIdPossessionFields: false,
                countryName: 'Canada',
                label: 'EIN',
                format: undefined,
                allowData: 'alphanumerics-only',
                fieldInService: 'FEDERAL',
                fieldInSAP: 'TAX1',
                maxLength: 15
            };
        case 'SG':
            return {
                showField: false,
                showFieldInMinimal: false,
                showTaxIdPossessionFields: false,
                countryName: 'Singapore'
            };
        case 'PH':
            return {
                showField: false,
                showFieldInMinimal: false,
                showTaxIdPossessionFields: false,
                countryName: 'Philippines'
            };
        case 'MY':
            return {
                showField: false,
                showFieldInMinimal: false,
                showTaxIdPossessionFields: false,
                countryName: 'Malaysia'
            };
        case 'HK':
            return {
                showField: false,
                showFieldInMinimal: false,
                showTaxIdPossessionFields: false,
                countryName: 'Hong Kong'
            };
        case 'JP':
            return {
                showField: false,
                showFieldInMinimal: false,
                showTaxIdPossessionFields: false,
                countryName: 'Japan'
            };
        case 'TH':
            return {
                showField: false,
                showFieldInMinimal: false,
                showTaxIdPossessionFields: false,
                countryName: 'Thailand'
            };
        case 'CL':
            return {
                showField: false,
                showFieldInMinimal: false,
                showTaxIdPossessionFields: false,
                countryName: 'Chile'
            };
        case 'BN':
            return {
                showField: false,
                showFieldInMinimal: false,
                showTaxIdPossessionFields: false,
                countryName: 'Brunei'
            };
        case 'HU':
            return {
                showField: false,
                showFieldInMinimal: false,
                showTaxIdPossessionFields: false,
                countryName: 'Hungary'
            };
        case 'RO':
            return {
                showField: false,
                showFieldInMinimal: false,
                showTaxIdPossessionFields: false,
                countryName: 'Romania'
            };
        case 'BE':
            return {
                showField: false,
                showFieldInMinimal: false,
                showTaxIdPossessionFields: false,
                countryName: 'Belgium'
            };
        case 'CZ':
            return {
                showField: false,
                showFieldInMinimal: false,
                showTaxIdPossessionFields: false,
                countryName: 'Czech Republic'
            };
        case 'RU':
            return {
                showField: false,
                showFieldInMinimal: false,
                showTaxIdPossessionFields: false,
                countryName: 'Russia'
            };
        case 'CH':
            return {
                showField: false,
                showFieldInMinimal: false,
                showTaxIdPossessionFields: false,
                countryName: 'Switzerland'
            };
        case 'SK':
            return {
                showField: false,
                showFieldInMinimal: false,
                showTaxIdPossessionFields: false,
                countryName: 'Slovakia'
            };
        case 'UA':
            return {
                showField: false,
                showFieldInMinimal: false,
                showTaxIdPossessionFields: false,
                countryName: 'Ukraine'
            };
        case 'LU':
            return {
                showField: false,
                showFieldInMinimal: false,
                showTaxIdPossessionFields: false,
                countryName: 'Luxembourg'
            };
        case 'PL':
            return {
                showField: false,
                showFieldInMinimal: false,
                showTaxIdPossessionFields: false,
                countryName: 'Poland'
            };
        case 'IL':
            return {
                showField: false,
                showFieldInMinimal: false,
                showTaxIdPossessionFields: false,
                countryName: 'Israel'
            };
        default:
            return null;
        }
    };
    return {
        getTaxIdConfigs: getTaxIdConfigs
    };
})();



//////////////////
// WEBPACK FOOTER
// /Users/geoffsagers/dev/webcomponents/js/packages/common-account/src/util/tax-id/business-tax-id-configs.js
// module id = 341
// module chunks = 0